import type { Country } from '../models';
import { Resource } from './resource';

export class PhoneNumbers extends Resource {
  resourcePath = 'v1/phone-numbers';

  async searchAvailablePhoneNumbers(
    areaCode?: string,
    contains?: string,
    countryCode?: string,
    locality?: string,
    near_number?: string,
    region?: string,
  ): Promise<{ phone_number: string }[]> {
    return this.api
      .get(this.path('available'), {
        params: {
          area_code: areaCode,
          contains: contains,
          country_code: countryCode,
          locality: locality,
          near_number: near_number,
          region: region,
        },
      })
      .then((response) => response.data.data);
  }

  async getSupportedCountries(): Promise<Country[]> {
    const response = await this.api.get(this.path('supported-countries'), {});

    const rawCountries = response.data.data;

    return rawCountries.map((c) => {
      return {
        name: c.name,
        isoCode: c.iso_country_code,
        callingCode: c.country_codes[0],
      };
    });
  }
}
